// src/components/navigation-bar/navigation-bar.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment NavigationBarTabsFragment on ProductNavigationBar {\n    tabs {\n      text\n      sectionName\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query NavigationBarQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    productNavigationBar(context: $context, productIdentifier: $productIdentifier) {\n      ...NavigationBarTabsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React3 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useRefContext } from "@shared-ui/ref-context";
import { useMockData } from "@shared-ui/retail-product-type-providers";
// src/components/navigation-bar/__private/__fragments/navigation-bar-tabs.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { UitkNavigationType, UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
var SCROLL_TIMEOUT = 1500;
var VISIBILITY_OPTIONS = {
    rootMargin: -60,
    thresholds: new Array(51).fill(0).map(function(v, i) {
        return i * 0.02;
    })
};
var fragment = gql(_templateObject());
var NavigationBarTabs = function(props) {
    var data = props.data, targets = props.targets;
    var tabs = data.tabs || [];
    var track = useClickTracker();
    var _React_useState = _sliced_to_array(React.useState(0), 2), activeTabIndex = _React_useState[0], setActiveTabIndex = _React_useState[1];
    var tabList = React.useMemo(function() {
        return tabs.map(function(tab) {
            return {
                id: tab.sectionName,
                ref: targets[tab.sectionName] || {
                    current: null
                }
            };
        });
    }, [
        tabs,
        targets
    ]);
    var onVisibilityChange = React.useCallback(function(visibilityEvents) {
        var newActiveTabIndex = -1;
        Object.keys(visibilityEvents).forEach(function(sectionName) {
            if (visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.SPAN_VIEWPORT) {
                newActiveTabIndex = tabs.findIndex(function(tab) {
                    return tab.sectionName === sectionName;
                });
            }
        });
        if (newActiveTabIndex >= 0) {
            setActiveTabIndex(newActiveTabIndex);
        }
    }, [
        tabs
    ]);
    var _useVisibility = useVisibility(tabList, onVisibilityChange, VISIBILITY_OPTIONS), disableObserver = _useVisibility.disableObserver, enableObserver = _useVisibility.enableObserver;
    var onTabSelect = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        disableObserver();
        setTimeout(enableObserver, SCROLL_TIMEOUT);
        var navigationTab = tabs[selectedTabIndex];
        if (navigationTab) {
            setActiveTabIndex(selectedTabIndex);
        }
    };
    var onTabClick = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        var navigationTab = tabs[selectedTabIndex];
        if (navigationTab === null || navigationTab === void 0 ? void 0 : navigationTab.analytics) {
            var analytics = navigationTab.analytics;
            track(analytics.referrerId, analytics.linkName);
        }
    };
    return /* @__PURE__ */ React.createElement(UitkTabs, {
        navigationType: UitkNavigationType.JUMPLINK,
        onTabSelect: onTabSelect,
        onTabClickCB: onTabClick,
        selectedTab: activeTabIndex,
        tabsType: UitkTabsType.NATURAL,
        scrollOffsetSelf: true,
        "data-stid": "navigation-tabs"
    }, tabs.map(function(tab) {
        return /* @__PURE__ */ React.createElement(UitkTab, {
            id: tab.sectionName,
            key: "uitk-tab-key-".concat(tab.sectionName),
            name: tab.text,
            targetRef: targets[tab.sectionName],
            targetURI: "#".concat(tab.sectionName)
        });
    }));
};
NavigationBarTabs.displayName = "sharedui-NavigationBarTabs";
NavigationBarTabs.fragment = fragment;
// src/components/navigation-bar/navigation-bar-placeholder.tsx
import React2 from "react";
import { UitkTabs as UitkTabs2 } from "uitk-react-tabs";
var NavigationBarPlaceholder = function() {
    return /* @__PURE__ */ React2.createElement(UitkTabs2, null);
};
// src/components/navigation-bar/navigation-bar.tsx
var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
var __Query = gql2(_templateObject1(), NavigationBarTabs.fragment);
var NavigationBar = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, batchKey = param.batchKey;
    var _mockData_product, _mockData_product1;
    var context = useBexApi().context;
    var getTargets = useRefContext().getTargets;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var mockData = useMockData();
    var _useQuery = useQuery(__Query, {
        context: {
            useApq: true,
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: variables,
        ssr: !skipSsr,
        skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_product = mockData.product) === null || _mockData_product === void 0 ? void 0 : _mockData_product.productNavigationBar
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React3.createElement(NavigationBarPlaceholder, null);
    }
    var productNavigationBar = (mockData === null || mockData === void 0 ? void 0 : (_mockData_product1 = mockData.product) === null || _mockData_product1 === void 0 ? void 0 : _mockData_product1.productNavigationBar) || (data === null || data === void 0 ? void 0 : data.productNavigationBar);
    if (error || !productNavigationBar) {
        return null;
    }
    var tabs = productNavigationBar.tabs;
    var targets = getTargets(tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
        return tab.sectionName;
    }));
    return /* @__PURE__ */ React3.createElement(NavigationBarTabs, {
        data: productNavigationBar,
        targets: targets
    });
};
NavigationBar.displayName = "sharedui-NavigationBar";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */ function(IdentifierType2) {
    IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
    IdentifierType2["CART_ID"] = "CART_ID";
    IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
    IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
    IdentifierType2["OFFER_ID"] = "OFFER_ID";
    IdentifierType2["ORDER_ID"] = "ORDER_ID";
    IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
    IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
    return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, NavigationBar }; // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map